import { useState } from 'react';
import { useOrganizationContext } from '../organization.context';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { UsersUploadWizard } from '../../components/upload-contexts/users';

export default function UploadUsers() {
  const { organization } = useOrganizationContext();
  const [open, setOpen] = useState(false);

  const dialogDescription = organization?.name;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="w-48">Import Users</Button>
      </DialogTrigger>
      <DialogContent className="h-4/5 min-w-[85%] flex flex-col">
        <DialogHeader className="space-y-0 mb-0">
          <DialogTitle>Import Users</DialogTitle>
          <DialogDescription>{dialogDescription}</DialogDescription>
        </DialogHeader>
        <UsersUploadWizard />
      </DialogContent>
    </Dialog>
  );
}
